import { GAME_ID, REDUX_ACTIONS } from '../../../data/constants';

const initialState = {
  comicPanel: 0,
  zoomedIn: false,
  alignGridToLeft: false,
  isZoomoutBeingBlocked: false,
};

const comicsPanelReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_COMIC_PANEL:
      return {
        ...state,
        comicPanel: payload,
      };

    case REDUX_ACTIONS.SET_COMIC_ZOOM:
      return {
        ...state,
        zoomedIn: payload,
      };

    case REDUX_ACTIONS.SET_BLOCKING_MULTI_IMAGE_ZOOMOUT:
      return {
        ...state,
        isZoomoutBeingBlocked: payload,
      };

    case REDUX_ACTIONS.SET_ALIGN_GRID_TO_LEFT:
      return {
        ...state,
        alignGridToLeft: payload,
      };

    case REDUX_ACTIONS.CHANGE_SCREEN:
      return { ...initialState };

    default:
      return state;
  }
};

export default comicsPanelReducer;
